import React, { useId, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';

export default function FitbitChartHelp({ title, children }: { title: string; children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return <>
    <Tooltip title={title}><IconButton size="small" aria-label={title} aria-haspopup="dialog" aria-expanded={open}
      aria-controls={open ? `${id}-dialog` : undefined} onClick={() => setOpen(true)}><HelpOutline fontSize="small" /></IconButton></Tooltip>
    <Dialog id={`${id}-dialog`} open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm"
      aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}>
      <DialogTitle id={`${id}-title`}>{title}</DialogTitle>
      <DialogContent><DialogContentText id={`${id}-description`}>{children}</DialogContentText></DialogContent>
      <DialogActions><Button autoFocus onClick={() => setOpen(false)}>Got it</Button></DialogActions>
    </Dialog>
  </>;
}
